import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HeartIcon, MessageCircleIcon, UserPlusIcon, AtSignIcon } from 'lucide-react';
import { Avatar } from '../components/ui/Avatar';
import { FollowButton } from '../components/ui/FollowButton';
import { MOCK_USERS } from '../data/mockData';
export function Notifications() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('All');
  const tabs = ['All', 'Likes', 'Comments', 'Mentions'];
  const MOCK_NOTIFICATIONS = [{
    id: 1,
    type: 'like',
    user: MOCK_USERS[1],
    text: 'liked your video',
    time: '2h',
    isNew: true
  }, {
    id: 2,
    type: 'comment',
    user: MOCK_USERS[2],
    text: 'commented: "This is hilarious 😂"',
    time: '4h',
    isNew: true
  }, {
    id: 3,
    type: 'follow',
    user: MOCK_USERS[3],
    text: 'started following you',
    time: '1d',
    isNew: false
  }, {
    id: 4,
    type: 'mention',
    user: MOCK_USERS[1],
    text: 'mentioned you in a comment',
    time: '2d',
    isNew: false
  }, {
    id: 5,
    type: 'like',
    user: MOCK_USERS[2],
    text: 'liked your comment',
    time: '3d',
    isNew: false
  }];
  const getIcon = (type: string) => {
    switch (type) {
      case 'like':
        return <HeartIcon size={14} className="text-white fill-white" data-id="element-422" />;
      case 'comment':
        return <MessageCircleIcon size={14} className="text-white fill-white" data-id="element-423" />;
      case 'follow':
        return <UserPlusIcon size={14} className="text-white" data-id="element-424" />;
      case 'mention':
        return <AtSignIcon size={14} className="text-white" data-id="element-425" />;
      default:
        return null;
    }
  };
  const getIconColor = (type: string) => {
    switch (type) {
      case 'like':
        return 'bg-neonOrange';
      case 'comment':
        return 'bg-blue-500';
      case 'follow':
        return 'bg-primary';
      case 'mention':
        return 'bg-purple-500';
      default:
        return 'bg-surface';
    }
  };
  const handleNotifClick = (type: string) => {
    if (type === 'follow') {
      navigate('/profile');
    } else {
      navigate('/feed');
    }
  };
  const renderNotif = (notif: (typeof MOCK_NOTIFICATIONS)[number], faded = false) => <div key={notif.id} role="button" tabIndex={0} onClick={() => handleNotifClick(notif.type)} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleNotifClick(notif.type);
    }
  }} className={`w-full flex items-center gap-3 text-left hover:bg-surface/40 -mx-4 px-4 py-2 rounded-lg transition-colors cursor-pointer ${faded ? 'opacity-80' : ''}`} data-id="element-426">
      <div className="relative" data-id="element-427">
        <Avatar src={notif.user.avatar} size="lg" data-id="element-428" />
        <div className={`absolute -bottom-1 -right-1 w-5 h-5 rounded-full border-2 border-black flex items-center justify-center ${getIconColor(notif.type)}`} data-id="element-429">
          {getIcon(notif.type)}
        </div>
      </div>
      <div className="flex-1" data-id="element-430">
        <p className="text-sm text-white leading-snug" data-id="element-431">
          <span className="font-bold" data-id="element-432">{notif.user.username}</span> {notif.text}
        </p>
        <span className="text-xs text-softGray" data-id="element-433">{notif.time}</span>
      </div>
      {notif.type === 'follow' ? <FollowButton data-id="element-434" /> : <div className={`w-12 h-16 ${faded ? 'bg-gradient-to-br from-emerald-500 to-teal-500' : 'bg-gradient-to-br from-purple-500 to-blue-500'} rounded-md shrink-0`} data-id="element-435" />}
    </div>;
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-436">
      <div className="px-4 pt-6 pb-2 bg-black z-10 sticky top-0" data-id="element-437">
        <h1 className="text-white font-poppins font-bold text-2xl mb-4" data-id="element-438">
          Inbox
        </h1>
        <div className="flex border-b border-border" data-id="element-439">
          {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className="flex-1 pb-3 relative" data-id="element-440">
              <span className={`text-sm font-bold transition-colors ${activeTab === tab ? 'text-white' : 'text-softGray'}`} data-id="element-441">
                {tab}
              </span>
              {activeTab === tab && <motion.div layoutId="notifTabIndicator" className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" data-id="element-442" />}
            </button>)}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar" data-id="element-443">
        <div className="px-4 py-2" data-id="element-444">
          <h2 className="text-white font-bold text-sm mb-2 mt-2" data-id="element-445">New</h2>
          <div className="space-y-1" data-id="element-446">
            {MOCK_NOTIFICATIONS.filter(n => n.isNew).map(notif => renderNotif(notif))}
          </div>

          <h2 className="text-white font-bold text-sm mb-2 mt-6" data-id="element-447">Earlier</h2>
          <div className="space-y-1" data-id="element-448">
            {MOCK_NOTIFICATIONS.filter(n => !n.isNew).map(notif => renderNotif(notif, true))}
          </div>
        </div>
      </div>
    </div>;
}